import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { weightData, addWeight, singlePatientMedicalData, labResults } from '../mockData/patient-meta-data';

const PatientMetaDataApi = [
  rest.get(`${API_ROOT}patient-meta-data`, (req, res, ctx) => {
    const variable = req.url.searchParams.get('variable');
    const medical = req.url.searchParams.get('medical');
    const patientId = req.url.searchParams.get('patientId');
    if (variable === 'weight') {
      return res(ctx.json(weightData));
    }
    if (medical === 'true' && patientId === '200') {
      return res(ctx.json(singlePatientMedicalData));
    }
    return res(
      ctx.json({
        allergies: [],
        diagnosis: [],
        symptoms: [],
        medications: [],
        variables: [],
      }),
    );
  }),
  rest.post(`${API_ROOT}patient-meta-data`, (req, res, ctx) => {
    const recheckRecommendation = req.url.searchParams.get('recheckRecommendation');
    if (recheckRecommendation === 'true') {
      return res(ctx.json(addWeight));
    }
    return res(ctx.json({ data: [] }));
  }),
  rest.delete(`${API_ROOT}patient-meta-data/${weightData.data[0].id}`, (req, res, ctx) => res(ctx.json([1]))),
  rest.get(`${API_ROOT}patient-lab-results`, (req, res, ctx) => res(ctx.json(labResults))),
];
export default PatientMetaDataApi;
